import * as constants from './constants';

export const setActiveProjectId = (projectId) => ({
  type: constants.SET_ACTIVE_PROJECT_ID,
  projectId
});

export const getProjectDetails = (projectId) => ({
  type: constants.GET_PROJECT_DETAILS,
  projectId
});

export const getProjectDetailsSuccess = (projectId, projectDetails) => ({
  type: constants.GET_PROJECT_DETAILS_SUCCESS,
  projectId,
  projectDetails
});

export const getProjectDetailsError = (projectId, error) => ({
  type: constants.GET_PROJECT_DETAILS_ERROR,
  projectId,
  error
});

export const getAllProjects = () => ({
  type: constants.GET_ALL_PROJECTS
});

export const getAllProjectsSuccess = (projects) => ({
  type: constants.GET_ALL_PROJECTS_SUCCESS,
  projects
});

export const getAllProjectsError = (error) => ({
  type: constants.GET_ALL_PROJECTS_ERROR,
  error
});

export const validateProjectId = () => ({
  type: constants.VALIDATE_PROJECT_ID
});
